const ErrorHandler = ({ error }: { error: { message: string } }) => (
  <div role='alert'>
    <p>An error occurred:</p>
    <pre>{error.message}</pre>
  </div>
)

export default ErrorHandler
